import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import Breadcrumbs from '../components/Breadcrumbs'
import { generateLocalBusinessSchema } from '../lib/structured-data-utils'

const blogPosts = [
  {
    path: '/blog/dubai-software-trends-2026',
    title: 'Top Software Development Trends in Dubai for 2026',
    description: 'Discover the leading software development trends shaping Dubai\'s tech landscape in 2026, from AI integration to cloud-native solutions.',
    date: '2026-01-15',
  },
  {
    path: '/blog/web-development-agency-dubai',
    title: 'How to Choose the Right Web Development Agency in Dubai',
    description: 'A practical guide to evaluating and selecting the best web development agency in Dubai for your business needs.',
    date: '2026-01-20',
  },
  {
    path: '/blog/mobile-app-development-cost-dubai',
    title: 'Mobile App Development Cost in Dubai: Complete Guide 2026',
    description: 'Understand the true cost of mobile app development in Dubai, including factors that affect pricing and how to budget effectively.',
    date: '2026-01-25',
  },
  {
    path: '/blog/digital-transformation-uae',
    title: 'Digital Transformation in UAE: A Business Guide for 2026',
    description: 'Learn how UAE businesses are embracing digital transformation in 2026 and what strategies drive real results.',
    date: '2026-02-01',
  },
  {
    path: '/blog/enterprise-software-dubai',
    title: 'Enterprise Software Solutions in Dubai',
    description: 'Explore the enterprise software landscape in Dubai, from ERP and CRM systems to custom-built solutions for large organisations.',
    date: '2026-02-10',
  },
  {
    path: '/blog/web-development-abu-dhabi-guide',
    title: 'Web Development in Abu Dhabi: Complete Guide',
    description: 'Everything you need to know about web development services in Abu Dhabi, from choosing the right partner to understanding project timelines.',
    date: '2026-02-15',
  },
  {
    path: '/blog/how-to-choose-devops-consultant-dubai',
    title: 'How to Choose a DevOps Consultant in Dubai',
    description: 'A comprehensive guide to finding and hiring the right DevOps consultant in Dubai for your infrastructure and deployment needs.',
    date: '2026-02-20',
  },
  {
    path: '/blog/cloud-migration-cost-uae',
    title: 'Cloud Migration Cost in UAE: Complete Guide for 2026',
    description: 'Break down the real costs of cloud migration in the UAE, including infrastructure, consulting, and ongoing operational expenses.',
    date: '2026-03-01',
  },
]

const Blog = () => {
  const localBusinessSchema = generateLocalBusinessSchema()

  const breadcrumbs = [
    { name: 'Blog', path: '/blog' },
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  }

  return (
    <>
      <SEO
        title="Blog - IT & Software Development Insights Dubai"
        description="Read expert insights on software development, cloud computing, DevOps, and digital transformation in Dubai and the UAE. Practical guides and industry trends from Demirix."
        keywords={[
          'dubai tech blog',
          'software development dubai',
          'IT insights UAE',
          'web development blog dubai',
          'cloud computing UAE',
          'digital transformation blog',
        ]}
        url="https://demirix.com/blog"
        structuredData={localBusinessSchema}
      />

      <motion.div
        className="section-padding"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="container-custom">
          <Breadcrumbs customCrumbs={breadcrumbs} />

          <motion.div variants={itemVariants} className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 dark:text-white mb-4">
              Blog
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Expert insights on software development, cloud computing, and digital transformation in Dubai and the UAE.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <motion.div key={post.path} variants={itemVariants}>
                <Link
                  to={post.path}
                  className="block h-full bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 p-6 border border-gray-100 dark:border-gray-700"
                >
                  <time
                    dateTime={post.date}
                    className="text-sm text-blue-600 dark:text-blue-400 font-medium"
                  >
                    {new Date(post.date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </time>
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-2 mb-3">
                    {post.title}
                  </h2>
                  <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                    {post.description}
                  </p>
                  <span className="text-blue-600 dark:text-blue-400 font-medium text-sm inline-flex items-center">
                    Read more
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </span>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>
    </>
  )
}

export default Blog
